document.addEventListener('alpine:init', () => {
  Alpine.store('productCartCounts', {
    counts: {},
    items: {},  // Store line items per product for quantity updates
    loading: false,
    updating: false,

    init() {
      // Fetch initial cart data
      this.fetchCart();

      // Listen for cart changes
      window.addEventListener('baseline:cart:afteradditem', () => {
        this.fetchCart();
      });

      window.addEventListener('baseline:cart:cartqtychange', () => {
        this.fetchCart();
      });

      window.addEventListener('baseline:cart:update', () => {
        this.fetchCart();
      });
    },

    async fetchCart() {
      if (this.loading) return;
      this.loading = true;

      try {
        const response = await fetch(window.theme.routes.cart_url + '.js', {
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const cart = await response.json();
        this.updateCounts(cart);
      } catch (error) {
        console.error('Error fetching cart for product counts:', error);
      } finally {
        this.loading = false;
      }
    },

    updateCounts(cart) {
      const newCounts = {};
      const newItems = {};

      if (cart && cart.items) {
        cart.items.forEach((item) => {
          const productId = item.product_id;
          if (newCounts[productId]) {
            newCounts[productId] += item.quantity;
          } else {
            newCounts[productId] = item.quantity;
          }
          // Store line items for this product
          if (!newItems[productId]) {
            newItems[productId] = [];
          }
          newItems[productId].push({ key: item.key, quantity: item.quantity });
        });
      }

      this.counts = newCounts;
      this.items = newItems;
    },

    getCount(productId) {
      return this.counts[productId] || 0;
    },

    // Increment: add 1 to the first line item for this product
    async increment(productId) {
      const productItems = this.items[productId];
      if (!productItems || productItems.length === 0) return;
      
      const item = productItems[0];
      await this.updateQuantity(item.key, item.quantity + 1);
    },

    // Decrement: remove 1 from the last line item for this product
    async decrement(productId) {
      const productItems = this.items[productId];
      if (!productItems || productItems.length === 0) return;
      
      const item = productItems[productItems.length - 1];
      await this.updateQuantity(item.key, item.quantity - 1);
    },

    async updateQuantity(key, quantity) {
      if (this.updating) return;
      this.updating = true;

      try {
        const response = await fetch(window.theme.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, quantity),
            sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (data.status !== 422) {
          this.updateCounts(data);
          document.body.dispatchEvent(
            new CustomEvent('baseline:cart:cartqtychange', {
              bubbles: true,
              detail: { response: data, key, quantity },
            })
          );
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      } finally {
        this.updating = false;
      }
    },
  });
});

